const agent = window.navigator.userAgent.toLowerCase()

const contains = string => agent.indexOf(string) !== -1 // eslint-disable-line no-magic-numbers

const ipad = contains('ipad')
const iphone = contains('iphone')
const ipod = contains('ipod')
const windows = contains('windows')

const ios = !windows && (ipad || iphone || ipod)
const android = !windows && contains('android')

let os

if (ios) {
  os = 'ios'
} else if (android) {
  os = 'android'
} else {
  // no mobile OS found
  os = false
}

export default os
